import * as React from 'react';
import classnames from 'classnames';
import { StockIndicator } from '@grandvisionhq/common';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import '@swc/helpers';
import '../../../../../../../context/actions.js';
import '../../../../../../../context/reducer.js';
import '../../../../../../../types/product.js';
import '../../../../../../../context/ProductContext.js';
import '../../../../../../../context/CmsContext.js';
import '../../../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import '../../../../../../../slots/context.js';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';
import { getEyeLabel } from '../utils.js';

const CLStockIndicator = ({ eyeSideId , className  })=>{
    const { isContactLensStockEnabled  } = useFeatureToggles();
    const intl = useIntl();
    const { state  } = useCLEcommContext();
    const eyeLabel = eyeSideId !== 'both' ? getEyeLabel(intl, eyeSideId) : undefined;
    const { stockIndicatorStatus , allowBackOrder  } = state.configurator[eyeSideId];
    if (!isContactLensStockEnabled) {
        return null;
    }
    /**
   * Render an empty wrapper when there is no status, so that the required space is reserved.
   * When there is a status, the page should not jump when the status is displayed.
   */ return /*#__PURE__*/ React.createElement("div", {
        className: classnames('cl-stock-indicator', className)
    }, stockIndicatorStatus && /*#__PURE__*/ React.createElement(React.Fragment, null, eyeLabel && /*#__PURE__*/ React.createElement("div", {
        className: "cl-stock-indicator__screenreader-text",
        "data-t": "cl-stock-indicator__screenreader-text"
    }, eyeLabel, ":"), /*#__PURE__*/ React.createElement(StockIndicator, {
        status: stockIndicatorStatus,
        isBackOrderAllowed: allowBackOrder
    })));
};

export { CLStockIndicator };
//# sourceMappingURL=CLStockIndicator.js.map
